import { CircleFilled } from '@1debit/icons';
import { type ReactNode } from 'react';

import { classNames } from '../../../server/utils/classNames';

export type BulletListItemContentProps = {
	title: string | ReactNode;
	description?: string | ReactNode;
	contentRight?: string | ReactNode;
	className?: string;
};

export const BulletListItemContent = ({ title, description, contentRight, className }: BulletListItemContentProps) => {
	return (
		<div className={classNames('flex w-full items-center grow h-12 gap-6', className)}>
			<div className="flex w-full items-center justify-between gap-2 min-w-0">
				<div className="flex flex-col justify-center min-w-0 ml-10">
					<div className="flex flex-row -ml-10">
						<CircleFilled className="h-2 my-auto mr-4" data-testid="circle-icon" />
						{typeof title === 'string' ? <span className="line-clamp-2 text-content-primary">{title}</span> : title}
					</div>
					{description &&
						(typeof description === 'string' ? (
							<span className="text-content-secondary line-clamp-1 text-body-sm sm:text-body">{description}</span>
						) : (
							description
						))}
				</div>
				{contentRight &&
					(typeof contentRight === 'string' ? (
						<span className="text-content-action-primary font-bold pl-6">{contentRight}</span>
					) : (
						contentRight
					))}
			</div>
		</div>
	);
};
